/**
 * Utility to access CSP nonce from middleware
 * The nonce is passed via the x-csp-nonce header and made available to the client
 */

export function getNonce(): string | undefined {
  if (typeof window !== 'undefined') {
    // Client-side: get from meta tag that _document.tsx sets
    const meta = document.querySelector('meta[name="csp-nonce"]');
    return meta?.getAttribute('content') || undefined;
  }
  return undefined;
}

/**
 * Set nonce in meta tag for client-side access
 * This should be called in _app.tsx with the nonce from the server
 */
export function setNonceInMeta(nonce: string): void {
  if (typeof window !== 'undefined') {
    let meta = document.querySelector('meta[name="csp-nonce"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'csp-nonce');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', nonce);
  }
}
